import Env from "../base/env";
import Channels from "../base/channels";
import Component from "gia/Component";
import { getViewport } from "../utils/utils";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    this.VARS = {
      TRIGGER: false,
    };
    this.call();
    this.observe();
  }

  call() {
    this.VARS.TRIGGER = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(this.DOM.view);

      const url = this.DOM.view.dataset.url;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.DOM.view.innerHTML = recommendations.innerHTML;
          }
          Channels.emit("smoothscroll::redraw");
        })
        .catch((e) => {
          console.error(e);
        });
    };
  }

  observe() {
    const viewport = getViewport();
    const observer = new IntersectionObserver(this.VARS.TRIGGER, {
      rootMargin: `0px 0px ${viewport.height}px 0px`,
    });

    observer.observe(this.DOM.view);
  }

  unmount() {}
}
